export default "__VITE_ASSET__2d4cac63__"